import React from 'react'

export default function PermissionErrorEmptyScreen({message,height}) {
    return (
        <div className={`flex flex-col items-center justify-center ${height}`}>
            <img src="/images/no-permission.svg" alt="img" loading='lazy' decoding='async' />
            <p className='text-xl font-normal text-[#000] pt-3'>{message}</p>
        </div>
    )
}
